import type { DocPageContent } from '../docs-content'

const page = {
  order: 7,
  slug: 'editing-tools',
  title: '编辑工具',
  description: '选择、剃刀、修剪、波纹、滚动、滑移、滑行和变速拉伸。',
  category: '核心编辑',
  sections: [
    {
      title: '核心工具',
      items: [
        '选择工具：移动、选择和排列片段。',
        '剃刀工具：直接在时间线上切割片段。',
        '修剪编辑工具：调整片段边缘。',
        '变速拉伸工具：通过改变播放速度来改变时长。',
      ],
    },
    {
      title: '修剪模式',
      items: [
        '波纹编辑：修改一处编辑并移动后续素材。',
        '滚动编辑：在相邻片段之间移动切割点。',
        '滑移编辑：改变片段内部的源帧而不移动片段本身。',
        '滑行编辑：移动片段的同时调整相邻编辑点。',
      ],
    },
    {
      title: '高级编辑操作',
      items: [
        '在播放头处插入冻结帧。',
        '当音视频关系需要改变时，链接或取消链接片段。',
        '为分组段落创建复合片段。',
        '使用便当布局将选中的视觉片段排列为结构化网格。',
      ],
    },
  ],
} satisfies DocPageContent

export default page